import Settings from "../Settings/Settings";
import PromptAnalysis from "./PromptAnalysis";
import OutputAnalysis from "./OutputAnalysis";
import RoutineExecutions from "./RoutineExecutions";
import ScheduledTasks from "./ScheduledTasks";
import Files from "./Files";
import GeneratedImages from "./GeneratedImages";
import AnnaSettings from "./AnnaSettings";
import useHashTab from "../../hooks/useHashTab";
import "./Admin.css";

const ADMIN_TABS = [
  "settings",
  "anna-settings",
  "prompt-analysis",
  "output-analysis",
  "routine-executions",
  "scheduled-tasks",
  "files",
  "generated-images",
];

function Admin() {
  const [tab, setTab] = useHashTab(ADMIN_TABS, "settings");

  return (
    <div className="admin-page">
      <div className="admin-header">
        <h2>Admin</h2>
      </div>
      <div className="tab-bar">
        <button
          className={`tab ${tab === "settings" ? "active" : ""}`}
          onClick={() => setTab("settings")}
        >
          Settings
        </button>
        <span className="tab-group-label">Anna</span>
        <button
          className={`tab ${tab === "anna-settings" ? "active" : ""}`}
          onClick={() => setTab("anna-settings")}
        >
          AI Settings
        </button>
        <button
          className={`tab ${tab === "prompt-analysis" ? "active" : ""}`}
          onClick={() => setTab("prompt-analysis")}
        >
          Prompt Analysis
        </button>
        <button
          className={`tab ${tab === "output-analysis" ? "active" : ""}`}
          onClick={() => setTab("output-analysis")}
        >
          Output Analysis
        </button>
        <button
          className={`tab ${tab === "routine-executions" ? "active" : ""}`}
          onClick={() => setTab("routine-executions")}
        >
          Routine Executions
        </button>
        <button
          className={`tab ${tab === "scheduled-tasks" ? "active" : ""}`}
          onClick={() => setTab("scheduled-tasks")}
        >
          Scheduled Tasks
        </button>
        <button
          className={`tab ${tab === "files" ? "active" : ""}`}
          onClick={() => setTab("files")}
        >
          Files
        </button>
        <button
          className={`tab ${tab === "generated-images" ? "active" : ""}`}
          onClick={() => setTab("generated-images")}
        >
          Generated Images
        </button>
      </div>

      {tab === "settings" && <Settings embedded />}
      {tab === "anna-settings" && <AnnaSettings />}
      {tab === "prompt-analysis" && <PromptAnalysis />}
      {tab === "output-analysis" && <OutputAnalysis />}
      {tab === "routine-executions" && <RoutineExecutions />}
      {tab === "scheduled-tasks" && <ScheduledTasks />}
      {tab === "files" && <Files />}
      {tab === "generated-images" && <GeneratedImages />}
    </div>
  );
}

export default Admin;
